import * as React from "react";
function SvgVoronoi(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M4.76 12.78L1 14.61v1.63l4.27 5.23L10 22l3-1.63v-4.94zm8 2.75l3.33-4.4-3-5-6.17.2-1.31 1.4-.92 5.13m18.44 6.07L14 22m1 5l4.79 2h2.13L26 26.53l-.5-6.07M13.06 6.13l2.48-4.87L21.85 1l3.48 2.87.67 2.26-1.13 3.2L21 11.67l-4.89-.53m8.72-1.8L31 13.93l-1.13 4.53-4.4 1.67-2.34-1.2L21 11.67M5 21l-2 4.33v1.6L7.18 31h2.56l5-4.07-.71-5.47-2.2-1.13"
        fill="none"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVoronoi);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
